import type { FC, SVGProps } from 'react';
import React from 'react';

type IconProps = SVGProps<SVGSVGElement>;

export const PlaybackIcon: FC<IconProps> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.00977 13.333C5.44809 13.9877 6.01231 14.5519 6.66699 14.9902L6.11035 15.8203C5.34708 15.3092 4.68969 14.652 4.17871 13.8887L5.00977 13.333Z"
      fill="white"
      fillOpacity="0.8"
    />
    <path
      d="M3.62402 8.73047L4.11426 8.82812C4.03945 9.20634 4 9.59807 4 10C4 10.4019 4.03945 10.7937 4.11426 11.1719L3.62305 11.2686L3.62402 11.2695L3.13379 11.3652C3.04648 10.9236 3 10.4672 3 10C3 9.53244 3.04636 9.07569 3.13379 8.63379L3.62402 8.73047Z"
      fill="white"
      fillOpacity="0.8"
    />
    <path
      d="M6.66699 5.00977C6.01231 5.44806 5.44809 6.01233 5.00977 6.66699L4.17871 6.11035C4.68972 5.34713 5.34711 4.6897 6.11035 4.17871L6.66699 5.00977Z"
      fill="white"
      fillOpacity="0.8"
    />
    <path d="M9 7.5L13 10L9 12.5V7.5Z" fill="white" fillOpacity="0.8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3662 3C14.2322 3 17.3662 6.13401 17.3662 10C17.3662 13.866 14.2322 17 10.3662 17C9.89857 17 9.44194 16.9527 9 16.8652L9.19434 15.8857C9.42732 15.9319 9.66507 15.9644 9.90692 15.9827C9.90473 15.9825 9.9091 15.9829 9.90692 15.9827C13.3357 16.2381 16.3662 13.4526 16.3662 10C16.3662 6.66957 13.5384 3.91772 10.2113 4.00196C9.86539 4.01072 9.52447 4.04894 9.19434 4.11426L9.09668 3.62305L9 3.13379C9.44192 3.04642 9.89867 3 10.3662 3Z"
      fill="white"
      fillOpacity="0.8"
    />
  </svg>
);
